<fz-banner
  *ngIf="advertisementTournament$ | async"
  [user]="currentUser"
  [timeZone]="currentUser?.user?.userSettings?.timezone"
  [tournament]="(advertisementTournament$ | async) || undefined"
  [actionBarConfig]="{ showJoinButton: true, showShareButton: true }"
  variant="promotion"
  (joinPress)="onJoinButtonPress()"
  (sharePress)="onSharePress()"
></fz-banner>
